<template>
  <div id="footer">
    <div class="footer_wrap">
      <div class="footer_logo_wrap">
        <img src="https://single.etnersplatform.com/files/202108059000137" alt="etners_pcs_footer_logo">
      </div>
      <div class="footer_text">
        <ul>
          <li>
            <a @click="popup('serviceTerms')" style="cursor: pointer">이용약관</a>
          </li>
          <li>
            <a @click="popup('privacy')" style="cursor: pointer"><b>개인정보처리방침</b></a>
          </li>
          <li>
            <span> 이트너스(주)<i>|</i>대표이사 : 임각균<i>|</i>경기도 과천시 과천대로7나길 60 과천어반허브 A동 5F (우.13840)<br>
          사업자번호 : 201-81-66865<i>|</i>개인정보 및 청소년 보호 책임자 : 진희창<i>|</i>대표전화 : 1533-4810 <i>|</i>팩스 : 070-8806-5190 <i>|</i>ⓒ 2022 etners Co.,Ltd </span>
          </li>
          <!----대표전화 : 031)628-6212<i>|</i>팩스 : 031)628-6299------>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  methods: {
    popup: function (fileNm) {
      if (fileNm === 'privacy') {
        window.open("https://etners.com/terms/management/detail/27/02")
      } else if (fileNm === 'serviceTerms'){
        window.open("https://etners.com/terms/management/detail/27/01")
      }
      // window.open('http://www.etners.com/privacy/esai/' + fileNm + '.html', fileNm)
    }
  }
}
</script>

<style scoped>
/*#footer{*/
/*  position: fixed;*/
/*  bottom: 0;*/
/*}*/
</style>
